import type VoiceCallConfig from '@/data/models/domain/VoiceCallConfig'

export interface IVoiceCallServerConfig {
  media: {
    remote: {
      video: HTMLVideoElement | boolean
      audio: HTMLAudioElement | boolean
    }
    constraints: MediaStreamConstraints
  }
  ua: VoiceCallConfig
}

export type TSound = {
  url: string
  loop: boolean
  volume: number
  audio?: HTMLAudioElement
  audioPromise?: Promise<void> | null
}
export type TIsMutedCallback = (phone: string) => Promise<boolean>
export type TmHTMLAudioElement = HTMLAudioElement & { setSinkId?: (sinkId: string) => Promise<void> }

export enum VoiceCallStatus {
  STATUS_HANGUP = 'hangup',
  STATUS_CALLING = 'calling',
  STATUS_BUSY = 'busy',
  STATUS_IN_PROGRESS = 'progress',
  STATUS_RINGING = 'ringing',
}

export const VOICE_CALL_STATUS_EVENT = 'voice-call:status' as const
export const VOICE_CALL_WARNING_EVENT = 'voice-call:warning' as const
export const VOICE_CALL_ERROR_EVENT = 'voice-call:error' as const
